import { AKSStageMap } from '@debbie/common/dist/customers/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Globe from '../../Icons/Globe.js';
import { CompanyRelationStyled, Tag } from './UserCompanyRelations.js';
const UserInfoCompanies = (props) => {
    const lang = useSelector((s) => s.lang);
    const { companies = null } = props;
    if (!companies) {
        return null;
    }
    return (React.createElement(React.Fragment, null, companies.map((cR) => (React.createElement(CompanyRelationStyled, null,
        React.createElement("h2", null,
            cR.name,
            ' ',
            React.createElement("span", null,
                React.createElement("span", null,
                    React.createElement(Globe, null),
                    " ",
                    lang.debtorInfo.company))),
        React.createElement("div", { className: "company-relation-address" }, cR.address && (React.createElement(React.Fragment, null,
            cR.address.address,
            cR.address.coAddress && `, c/o ${cR.address.coAddress}`,
            ",",
            React.createElement("br", null),
            cR.address.zipcode,
            " ",
            cR.address.city,
            cR.address.country && (React.createElement(React.Fragment, null,
                ",",
                React.createElement("br", null),
                " ",
                cR.address.country))))),
        cR.KOBstatus && (React.createElement("p", null,
            lang.debtorInfo.companyStatus,
            ":",
            ' ',
            // @ts-ignore
            lang.debtorInfo.status[AKSStageMap[cR.KOBstatus]] ||
                cR.KOBstatus)),
        React.createElement("p", null,
            React.createElement("div", { className: "relation-roles" },
                React.createElement("h3", null, lang.debtorInfo.roles),
                React.createElement(Tag, null, lang.debtorInfo.accountableParticipant))))))));
};
export default UserInfoCompanies;
//# sourceMappingURL=UserCompanies.js.map